export default __webpack_public_path__ + "static/media/hht2_ep18_timeline_04.155f2bfc.png";